import script from "./CalendarLegend.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarLegend.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarLegend.vue?vue&type=style&index=0&id=33fdc464&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33fdc464"]])

export default __exports__